import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';

import { ArticleHeading4 } from '@cian/ui-kit';

import { ITabsProps } from '../types';

type TDesktopViewProps = ITabsProps & {
  ref?: React.Ref<HTMLDivElement>;
};

export function DesktopView({ tabs, dealType, onChange, ref }: TDesktopViewProps): React.JSX.Element {
  return (
    <div ref={ref} data-testid="TabsDesktopViewId" className={styles['container']}>
      {tabs.map(tab => {
        const isActiveTab = tab.value === dealType;
        const color = tab.disabled ? 'gray40_100' : isActiveTab ? 'accent-main-primary' : 'theme-dark';

        return (
          <div
            key={tab.value}
            data-testid={`tab_item_${tab.value}`}
            className={cn(styles['tab'], {
              [styles['tab-active']]: isActiveTab,
              [styles['tab-disabled']]: tab.disabled,
            })}
            onClick={() => !tab.disabled && onChange(tab.value)}
          >
            <ArticleHeading4 color={color}>{tab.label}</ArticleHeading4>
          </div>
        );
      })}
    </div>
  );
}
